<template>
  <print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 도급·용역·위탁 시 자체 기준 준수 여부 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="도급·용역·위탁 시 자체 기준 준수 여부"
      thema="label"
      pcContentAreaClass="flex"
      :tableData="[
        { id: '사업명', title: '사업명', type: 'field', middle: true },
        { id: '구분', title: '인증구분여부', type: 'radio', radioItems: [{ value: '도급' }, { value: '용역' }, { value: '위탁' }], style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px' },
        { id: '의무이행서약서', title: '의무이행서약서', type: 'radio', radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }], style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px' },
        {
          id: '과업지시서',
          title: '과업지시서<br/>안전보건확보 의무 명시',
          type: 'radio',
          radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }],
          style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px',
        },
        {
          id: '정량평가',
          title: '협상 계약 정량평가 항목비고',
          type: 'radio',
          radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }],
          style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px',
        },
        {
          id: '위탁협약서',
          title: '위탁협약서<br/>안전보건확보 의무 명시',
          type: 'radio',
          radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }],
          style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px',
        },
        { id: '가감점', title: '공개입찰 계약시 가감점', type: 'radio', radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }], style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px' },
      ]"
      v-model="form.자체기준준수여부"
    >
      <template #headButton>
        <field-selector :readonly="board.readonly" :multiple="true" :onlyButton="true" btnTitle="사업등록" class="mr-4" v-model="selectTemp1" @select="addSelfCriteriaCompliance" />
      </template>
    </table-custom>

    <!-- 도급사업에 대한 해당 부서 자체점검 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="도급사업에 대한 해당 부서 자체점검"
      thema="label"
      pcContentAreaClass="flex"
      :tableData="[
        { id: '사업명', title: '사업명', type: 'field', width: 200, middle: true },
        { id: '예산', title: '예산<br/>(백만원)', type: 'number', width: 150, middle: true },
        { id: '협의체구성운영', title: '협의체<br/>구성·운영', type: 'radio', radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }], style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px' },
        { id: '작업장순회점검', title: '작업장<br/>순회점검', type: 'radio', radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }], style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px' },
        {
          id: '안전보건교육확인지원',
          title: '안전보건교육 확인 지원',
          type: 'radio',
          radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }],
          style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px',
        },
        {
          id: '경보체계운영대피방법등훈련',
          title: '경보체계 운영 대피방법 등 훈련',
          type: 'radio',
          radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }],
          style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px',
        },
        {
          id: '위생시설이용',
          title: '위생시설<br/>이용',
          type: 'radio',
          radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }],
          style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px',
        },
        { id: '합동안전점검', title: '합동<br/>안전점검', type: 'radio', radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }], style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px' },
        { id: '위험성평가', title: '위험성평가', type: 'radio', radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }], style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px' },
        { id: '작업환경측정', title: '작업환경<br/>측정', type: 'radio', radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }], style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px' },
        { id: '안전정보제공', title: '안전<br/>정보제공', type: 'radio', radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }], style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px' },
        { id: '시정조치', title: '시정조치', type: 'radio', radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }], style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px' },
        {
          id: '보건관리비감독',
          title: '산업안전<br/>보건관리비 감독',
          type: 'radio',
          radioItems: [{ value: '여' }, { value: '부' }, { value: '해당없음' }],
          style: 'flex-direction: column; align-items: flex-start !important; padding: 6px 9px',
        },
      ]"
      v-model="form.자체점검"
    >
      <template #headButton>
        <field-selector :readonly="board.readonly" :multiple="true" :onlyButton="true" btnTitle="사업등록" class="mr-4" v-model="selectTemp2" @select="addSelfInspection" />
      </template>
    </table-custom>

    <!-- 중대산업재해 부서별 점검결과 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 중대산업재해 부서별 점검결과</h5>
      </div>
      <table class="mt-4">
        <colgroup>
          <col />
          <col width="140" />
          <col width="140" />
          <col width="380" />
        </colgroup>
        <thead>
          <tr>
            <th>의무이행 점검 사항</th>
            <th>부서점검</th>
            <th>중대재해예방팀</th>
            <th>비고 및 조치요구사항</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in form.inspectList" :key="index">
            <th>
              <span class="mr-1">{{ ++index }}.</span>
              <span v-html="item.content.replace(/\n/g, '<br>')" />
            </th>
            <td>
              <p v-if="isPrint">{{ item.부서점검 }}</p>
              <vs-select v-else class="w-full flex-1" autocomplete v-model="item.부서점검">
                <vs-select-item v-for="(option, optionIndex) in ['적정', '미흡', '해당없음']" :key="`부서점검_${index}_${optionIndex}`" :text="option" :value="option" />
              </vs-select>
            </td>
            <td>
              <p v-if="isPrint">{{ item.중대재해예방팀 }}</p>
              <vs-select v-else class="w-full flex-1" autocomplete v-model="item.중대재해예방팀">
                <vs-select-item v-for="(option, optionIndex) in ['적정', '미흡', '해당없음']" :key="`중대재해예방팀_${index}_${optionIndex}`" :text="option" :value="option" />
              </vs-select>
            </td>
            <td>
              <ml-input v-if="!isPrint" v-model="item.비고" class="w-full" />
              <p v-else>{{ item.비고 }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import FieldSelector from "@/components/selector/FieldSelector";
import * as inspectData from "./inspectData";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
    FieldSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        자체기준준수여부: [],
        자체점검: [],

        
        inspectList: inspectData.inspectTable,
      },

      selectTemp1: [],
      selectTemp2: [],
    };
  },
  methods: {
    addSelfCriteriaCompliance(data) {
      data.forEach((row) => {
        const randomId = Math.floor(Math.random() * 1000000) + new Date().getTime();
        this.form.자체기준준수여부.push({
          id: randomId,
          사업명: row.id,
        });
      });
      this.selectTemp1 = [];
    },
    addSelfInspection(data) {
      data.forEach((row) => {
        const randomId = Math.floor(Math.random() * 1000000) + new Date().getTime();
        this.form.자체점검.push({
          id: randomId,
          사업명: row.id,
        });
      });
      this.selectTemp2 = [];
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    th,
    td {
      font-size: 14px;
      font-weight: 500;

      text-align: center;
      border: 1px solid #cdcdcd;
      padding: 15px;
    }

    th {
      background: #f9f9f9;
    }
  }
  tbody {
    th {
      font-size: 14px;
      font-weight: 500;

      text-align: start;
      padding: 15px;
    }

    td {
      padding: 5px;
    }

    th,
    td {
      border: 1px solid #cdcdcd;
    }
  }
}
</style>
